/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Volume_TitleInputs */

const en_us2_progress_volume_title = /** @type {(inputs: Progress_Volume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly volume`)
};

const pt_br2_progress_volume_title = /** @type {(inputs: Progress_Volume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume semanal`)
};

const es_419_progress_volume_title = /** @type {(inputs: Progress_Volume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen semanal`)
};

const pt_pt2_progress_volume_title = /** @type {(inputs: Progress_Volume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume semanal`)
};

const fr_fr2_progress_volume_title = /** @type {(inputs: Progress_Volume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume hebdomadaire`)
};

const de_de2_progress_volume_title = /** @type {(inputs: Progress_Volume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochenvolumen`)
};

const it_it2_progress_volume_title = /** @type {(inputs: Progress_Volume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume settimanale`)
};

/**
* | output |
* | --- |
* | "Weekly volume" |
*
* @param {Progress_Volume_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_volume_title = /** @type {((inputs?: Progress_Volume_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Volume_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_volume_title(inputs)
	if (locale === "es-419") return es_419_progress_volume_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_volume_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_volume_title(inputs)
	if (locale === "de-DE") return de_de2_progress_volume_title(inputs)
	if (locale === "it-IT") return it_it2_progress_volume_title(inputs)
	return en_us2_progress_volume_title(inputs)
});
export { progress_volume_title as "progress.volume_title" }